var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncluded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M35.283,141.285l-17.913,11.718l-17.37,-11.718c4.524,-78.786 69.945,-141.285 150,-141.285c80.055,0 145.476,62.499 150,141.285l-19.101,-11.718l-16.185,11.718c-2.046,-27.393 -13.71,-52.866 -33.369,-72.492c-21.726,-21.69 -50.619,-33.636 -81.345,-33.636c-30.729,0 -59.619,11.946 -81.348,33.636c-19.656,19.626 -31.323,45.099 -33.369,72.492Zm196.062,89.919c-21.726,21.693 -50.619,33.639 -81.345,33.639c-30.729,0 -59.619,-11.946 -81.348,-33.639c-19.656,-19.623 -31.323,-45.096 -33.369,-72.489l-18.795,11.718l-16.488,-11.718c4.524,78.786 69.945,141.285 150,141.285c80.055,0 145.476,-62.499 150,-141.285l-19.101,-11.718l-16.185,11.718c-2.043,27.393 -13.71,52.866 -33.369,72.489Zm-25.071,-141.261l-75.033,74.901l-37.515,-37.449l-28.239,28.188l65.754,65.637l103.269,-103.089l-28.236,-28.188Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncluded);
export default __webpack_public_path__ + "static/media/included.b4061e31.svg";
export { ForwardRef as ReactComponent };